// extracted by mini-css-extract-plugin
export default {"questions":"show_questions__8R5-5"};